/**
 * Long product titles wrap to two lines on mobile, pushing the whole form
 * (color, size, add to cart) further down the page. Clamp to one line with
 * an ellipsis, and let shoppers tap it to read the full title if it was
 * actually cut off.
 */
(function () {
  function refresh(heading) {
    var wasExpanded = heading.classList.contains(
      "product-title-heading--expanded",
    );
    if (wasExpanded) {
      heading.classList.remove("product-title-heading--expanded");
    }

    var isTruncatable = heading.scrollWidth > heading.clientWidth;

    if (wasExpanded && isTruncatable) {
      heading.classList.add("product-title-heading--expanded");
    }

    heading.classList.toggle(
      "product-title-heading--truncatable",
      isTruncatable,
    );

    if (isTruncatable) {
      heading.setAttribute("role", "button");
      heading.setAttribute("tabindex", "0");
      heading.setAttribute(
        "aria-expanded",
        heading.classList.contains("product-title-heading--expanded")
          ? "true"
          : "false",
      );
    } else {
      heading.removeAttribute("role");
      heading.removeAttribute("tabindex");
      heading.removeAttribute("aria-expanded");
      heading.classList.remove("product-title-heading--expanded");
    }
  }

  function toggle(heading) {
    if (!heading.classList.contains("product-title-heading--truncatable"))
      return;
    var expanded = heading.classList.toggle(
      "product-title-heading--expanded",
    );
    heading.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function refreshAll() {
    document
      .querySelectorAll(".product-title-heading")
      .forEach(refresh);
  }

  document.addEventListener("click", function (event) {
    var heading = event.target.closest(
      ".product-title-heading--truncatable",
    );
    if (heading) toggle(heading);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var heading = event.target.closest(
      ".product-title-heading--truncatable",
    );
    if (!heading) return;
    event.preventDefault();
    toggle(heading);
  });

  document.addEventListener("DOMContentLoaded", refreshAll);
  window.addEventListener("load", refreshAll);

  if (typeof webvista !== "undefined" && webvista.subscribe) {
    webvista.subscribe(PUB_SUB_EVENTS.variantChange, refreshAll);
  }

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshAll, 200);
  });
})();
